import { mapApiImageToImageProps } from './common.mappers';
import { mapApiCategoriesToCategoryProps } from './use-case.mappers';

import type { FUseCaseHomeTemplateProps } from '@/components/templates/FUseCaseHomeTemplate.vue';

export function mapApiDataToUseCaseHome(
  useCaseHomeRawData: StrapiResponseData<UseCaseHomeContentType> | undefined,
  useCasesCardsRawData: StrapiResponseData<UseCaseContentType>[] | undefined
): FUseCaseHomeTemplateProps {
  const useCaseHomeDataAttributes = useCaseHomeRawData?.attributes;
  const { t } = useI18n();

  return {
    youtubeVideoId: useCaseHomeDataAttributes?.youtube_video_id,
    videoPlaceholderImage: mapApiImageToImageProps(
      useCaseHomeDataAttributes?.video_placeholder_image?.data?.attributes
    ),
    parallaxTrailImages: (useCaseHomeDataAttributes?.images?.data ?? []).map(
      image => mapApiImageToImageProps(image?.attributes)
    ),
    featuredUseCase: {
      title:
        useCaseHomeDataAttributes?.featured_use_case?.data?.attributes?.hero
          ?.title ?? '',
      excerpt:
        useCaseHomeDataAttributes?.featured_use_case?.data?.attributes?.hero
          ?.description ?? '',
      image: mapApiImageToImageProps(
        useCaseHomeDataAttributes?.featured_use_case?.data?.attributes?.hero
          ?.image_background?.data?.attributes
      ),
      ctaLocation: `/case-studies/${
        useCaseHomeDataAttributes?.featured_use_case?.data?.attributes?.slug ??
        ''
      }`,
    },
    featuredGuide: {
      image: mapApiImageToImageProps(
        useCaseHomeDataAttributes?.featured_guide?.data?.attributes?.image?.data
          ?.attributes
      ),
      title:
        useCaseHomeDataAttributes?.featured_guide?.data?.attributes?.title ??
        '',
      excerpt:
        useCaseHomeDataAttributes?.featured_guide?.data?.attributes?.excerpt ??
        '',
      ctaLocation: `/resources/guides/${
        useCaseHomeDataAttributes?.featured_guide?.data?.attributes?.slug ?? ''
      }`,
    },
    useCaseCards: (useCasesCardsRawData ?? [])
      ?.sort((a, b) => (a.attributes?.rank ?? 0) - (b.attributes?.rank ?? 0))
      .map(useCaseCard => ({
        categoryName: mapApiCategoriesToCategoryProps(
          useCaseCard?.attributes?.categories,
          useCaseCard?.attributes?.forced_augmented_bike_network ?? false
        ),
        title: useCaseCard?.attributes?.title_short ?? '',
        cityName: useCaseCard?.attributes?.city_name ?? '',
        image: mapApiImageToImageProps(
          useCaseCard?.attributes?.lifestyle_image?.data?.attributes
        ),
        link: {
          location:
            useCaseCard?.attributes?.redirect_url ??
            `/case-studies/${useCaseCard?.attributes?.slug ?? ''}`,
          text: t('use_case__card_link_text'),
        },
      })),
  };
}
